export enum EDomainStatus {
	Unknown = 'Unknown',
	RegistrationPendingLevitateSupport = 'RegistrationPendingLevitateSupport',
	RegistrationInProgress = 'RegistrationInProgress',
	RegistrationFailed = 'RegistrationFailed',
	RegistrationComplete = 'RegistrationComplete',
	EmailValidationInProgress = 'EmailValidationInProgress',
	EmailValidationFailed = 'EmailValidationFailed',
	EmailValidationComplete = 'EmailValidationComplete',
	Released = 'Released',
}

export function getDomainStatusMessage(status: EDomainStatus): string {
	switch (status) {
		case EDomainStatus.Unknown:
			return 'Domain status is unknown';
		case EDomainStatus.RegistrationPendingLevitateSupport:
			return 'Registration is pending Levitate support';
		case EDomainStatus.RegistrationInProgress:
			return 'Registration is in progress';
		case EDomainStatus.RegistrationFailed:
			return 'Registration failed';
		case EDomainStatus.RegistrationComplete:
			return 'Registration is complete';
		case EDomainStatus.EmailValidationInProgress:
			return 'SendGrid validation is in progress';
		case EDomainStatus.EmailValidationFailed:
			return 'SendGrid validation failed';
		case EDomainStatus.EmailValidationComplete:
			return 'Ready';
		case EDomainStatus.Released:
			return 'Domain has been released';
		default:
			return 'Domain status unknown';
	}
}
